<template>
  <div class="commonAgreement_container">
    <div class="agreement_main">
      <div>
        <h1>劳务协议</h1>
        <div>
          甲方：<span>{{ data.agreement_company_name }}</span>
        </div>
        <div style="display: flex">
          乙方：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.name }}
          </div>
        </div>
        <!-- <div style="display: flex">
          联系方式：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.phone }}
          </div>
        </div> -->

        <div class="agreement_margin_p">
          于
          <span class="agreement_underline">
            “{{ data.meet_start_time?.split("-")[0] }}年
            {{ data.meet_start_time?.split("-")[1] }}月
            {{ data.meet_start_time?.split("-")[2].substr(0, 2) }}日”</span
          >
          开展的<span class="agreement_underline">“2026规范院院行”</span
          >项目，乙方为甲方在执行期间提供
          <span class="agreement_underline">{{ data.role_name }}</span>
          劳务服务。为明确双方义务及权利，依据《中华人民共和国民法典》等其他相关法律法规之规定，双方在平等自愿基础之上达成以下一致协议：
        </div>

        <h3>第一条 合同期限</h3>
        <p class="agreement_content_row">
          自本协议签署之日起至本项目结束之日止。
        </p>
      </div>

      <div>
        <h3>第二条 乙方提供的劳务内容</h3>
        <p class="agreement_content_row">
          疾病领域宣讲、培训、咨询服务、内容特许使用权等与项目教育相关的内容。
        </p>
      </div>

      <div>
        <h3>第三条 劳务费用支付及方式</h3>
        <p class="agreement_content_row">
          本合同采用按次结算，每次劳务费税后<span class="agreement_underline">
            ￥{{ data.money }}
            <!-- （大写{{
              $tools.intToChinese(data.money)
            }}
            ） --> </span
          >元整，支付方式经双方协商结算。
        </p>
        <div style="display: flex">
          账户名称：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.name }}
          </div>
        </div>
        <div style="display: flex">
          身份证号：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.id_card_number }}
          </div>
        </div>
        <div style="display: flex">
          开户行：
          <div style="flex: 1 0 0" class="agreement_underline">
            {{ data.bank_name }}{{ data.bank_name_point }}
          </div>
        </div>

        <div style="display: flex">
          银行卡号：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.bank_number }}
          </div>
        </div>
        <div style="display: flex">
          手机号：
          <div class="agreement_underline" style="flex: 1 0 0">
            {{ data.phone }}
          </div>
        </div>
      </div>

      <div>
        <h3>第四条 双方的基本权利与义务</h3>
        <p class="agreement_content_row">
          1、如乙方严重违反合同约定及法律规定，甲方有权终止协议。
        </p>
        <p class="agreement_content_row">
          2、乙方由于个人原因所发生的疾病以及伤残等意外事故，乙方自行负责。
        </p>
        <p class="agreement_content_row">
          3、任何一方单方面解除本协议的，需以书面通知另一方，经双方协商终止本协议。
        </p>
        <p class="agreement_content_row">
          4、双方应严格保守在合作过程中所了解的商业及技术机密，否则应对因此造成的损失承担赔偿。
        </p>
        <p class="agreement_content_row">
          5、本协议解除或终止时，乙方应向甲方指定的人员交接工作；并立即停止以甲方名义从事一切活动；交接清晰一些与工作相关的事务。
        </p>
        <p class="agreement_content_row">
          6、乙方应按照甲方要求提供劳务服务，不得弄虚作假。
        </p>
        <p class="agreement_content_row">
          7、乙方保证具有完成劳务服务的专业知识与经验，不得提供虚假履历与身份信息。
        </p>
        <p class="agreement_content_row">
          8、乙方在本项目宣讲过程中所载有肖像的视频、音频、录像及照片等资料，乙方同意甲方在全球范围内免费使用，同意甲方用于学习及科学研究。
        </p>
        <p class="agreement_content_row">
          9、甲方依法为乙方代扣代缴个人所得税，乙方应当如实按照我国税法相关规定进行居民个人综合所得年度汇算申报。
        </p>
      </div>
      <div>
        <h3>第五条本协议解除终止情形：</h3>
        <p class="agreement_content_row">1、双方就解除本协议协商一致的；</p>
        <p class="agreement_content_row">
          2、乙方专业能力无法完成合同约定内容的。
        </p>
        <p class="agreement_content_row">
          3、因不可抗力或其他原因致使本协议无法继续履行的。
        </p>
      </div>
      <div>
        <h3>第六条 其他</h3>
        <p class="agreement_content_row">
          1、本协议如有未尽事宜，双方另行签订补充协议，补充协议与本协议具有同等法律效力。
        </p>
        <p class="agreement_content_row">
          2、双方因本协议发生争议首先应友好协商解决，协商不成的，均可向甲方所在地人民法院诉讼解决。
        </p>
        <p class="agreement_content_row">
          3、协议一式两份，甲、乙双方各执一份，经甲方盖章,乙方签字之日起生效。
        </p>
      </div>
    </div>
    <div class="agreement_sign_info">
      <div class="agreement_sign_them">
        <div class="agreement_sign_name">
          <span>甲方（盖章）：</span>{{ data.agreement_company_name }}
        </div>
        <div class="agreement_sign_date">
          日期：{{ $tools.getDate(data.meet_start_time, "yyyy年MM月dd日") }}
        </div>
      </div>
      <div class="agreement_sign_them">
        <div class="agreement_sign_name">
          <span ref="signData_one">乙方：</span>
          <customButton
            @click="doSignName(0)"
            v-if="!(data.meet_sign_name?.split(',')[0] || this.signData[0])"
          >
            <div>
              <span>签名</span>
            </div>
          </customButton>
          <img
            :src="data.meet_sign_name?.split(',')[0] || this.signData[0]"
            @click="doSignName(0)"
            v-else
            alt=""
          />
        </div>
        <div class="agreement_sign_date">
          日期：{{ $tools.getDate(data.meet_start_time, "yyyy年MM月dd日") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import customButton from "@/components/unit/CustomButton";
import { CircleCheck } from "@element-plus/icons";
import "../../../../assets/icon/iconfont.css";
export default {
  name: "commonAgreement",
  props: {
    agreementData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    agreementFields: {
      type: Object,
      default: () => {
        return [];
      },
    },
    signData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      data: {},
      content: {
        大会主席: "大会开场发表致辞以及总结",
        会议讲者: "就学术专题发表演讲",
        讨论嘉宾: "参与会议讨论环节的讨论、点评",
      },
      role: ["主席", "讲者", "讨论嘉宾"],
    };
  },
  components: {
    customButton,
    CircleCheck,
  },
  mounted() {
    this.initData(this.agreementData, this.agreementFields);
    setTimeout(() => {
      this.$emit("initScroll");
    }, 1000);
  },
  methods: {
    initData(data) {
      this.data = data;
      this.role.map((v) => {
        if (v.includes(this.data.role_name)) this.data.role_name = v;
      });
      console.log(" this.role :>> ", this.role);
    },
    verifyData() {
      if (!this.signData[0]) {
        let height = this.$refs.signData_one.offsetTop;
        this.$emit("scrollTo", height - 100);
        this.$tips.error({ text: "请签署签名" });
        return false;
      }
      // if (!this.signData[1]) {
      //   let height = this.$refs.signData_twe.offsetTop;
      //   this.$emit("scrollTo", height - 100);
      //   this.$tips.error({ text: "请先签署第二个签名" });
      //   return false;
      // }
      return true;
    },
    doSignName(index) {
      this.$emit("doSignName", index);
    },
  },
};
</script>
<style>
.commonAgreement_container {
  word-break: break-all;
}
.agreement_sign_info {
  display: flex;
}
.agreement_sign_them {
  flex: 1 0 0;
  margin-right: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.agreement_sign_info > div {
  flex: 1 0 0;
  margin-top: 1.5rem;
}
.agreement_sign_name {
  /* height: 2.5rem; */
  flex: 1 0 0;
  display: flex;
  align-items: center;
}
.agreement_sign_name span {
  white-space: nowrap;
}
.agreement_sign_name img {
  width: 6rem;
  height: auto;
}
.agreement_margin_p {
  margin: 0.75rem 0;
}
.agreement_font_bold {
  font-weight: 600;
}
.agreement_content_two_stage_title {
  text-indent: 1rem;
}
.attached_table {
  margin-top: 1.25rem;
}
.commonAgreement_container .agreement_table {
  width: 100%;
  height: 100%;
  border: 1px solid #000;
  margin-bottom: 2rem;
}
.commonAgreement_container .agreement_row {
  display: flex;
  min-height: 1.5rem;
}
.agreement_td {
  /* font-size: 4vw; */
  padding: 0.25rem 0.5rem;
  line-height: 1.5rem;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  word-break: break-all;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.commonAgreement_container .agreement_td div {
  line-height: 1.2rem;
}
.commonAgreement_container
  .agreement_table_one
  .agreement_row
  .agreement_td:first-child {
  flex: 1 0 0;
}
.commonAgreement_container
  .agreement_table_one
  .agreement_row
  .agreement_td:last-child {
  flex: 8.75rem 0 0;
  border-right: 0;
}
.commonAgreement_container
  .agreement_table_two
  .agreement_row
  .agreement_td:first-child {
  flex: 5.25rem 0 0;
}
.commonAgreement_container
  .agreement_table_two
  .agreement_row
  .agreement_td:last-child {
  flex: 1 0 0;
  border-right: 0;
}
.commonAgreement_container .agreement_row:last-child > .agreement_td {
  border-bottom: 0;
}
.commonAgreement_split_line {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  margin-top: 1.25rem;
}
.split_line {
  height: 0px;
  flex: 1 0 0;

  border-bottom: #000 0.25rem dashed;
}
.agreement_td_ul {
  padding-left: 1rem;
}
.agreement_td_direction {
  flex-direction: inherit !important;
  /* align-items: center; */
}
.icon-check {
  /* font-size: 1.5rem !important; */
}
</style>